<template>
	<div class="link-auto-table-search">
		<link-select
			:placeholder="$t('LinkForm.selectSearchField')+'...'"
			:width="autoOption.searchSelectWidth"
			:data="lv_linkFilterOptions"
			labelKey="title"
			valKey="field"
			v-model="lv_searchField"
		/>
		<link-dynamic-filter :value="lv_dynamicFilter" @change="handleFilterChange" ref="filter" :searchIcon="searchIcon"/>
		<link-button :label="$t('LinkForm.query')" @click="search"/>
		<link-auto-table-filter-store :option="autoOption" v-if="!!autoOption.storeFilterButton"/>
	</div>
</template>

<script>
	import {AutoTableFilter} from "./index";
	import LinkAutoTableFilterStore from "../link-auto-table-filter-store";

	export default {
		name: "link-auto-table-search",
		components: {LinkAutoTableFilterStore},
		props: {
			autoOption: {require: true},                                        //autoTable的autoOption配置参数
			searchField: {type: String, require: true},                         //当前搜索字段
			linkFilterOptions: {require: true},                                 //标准筛选配置参数
			dynamicFilter: {require: true},                                     //搜索栏筛选值对象
			searchIcon: {type: Boolean, default: true},
		},
		watch: {
			linkFilterOptions: {
				immediate: true,
				async handler(val) {
					await this.$lv.nextTick()
					val = this.lv_linkFilterOptions
					if (!val) return
					/*如果希望初始化的时候为全字段查询，设置searchField为undefined即可*/
					if (this.autoOption.searchField === null && Boolean(val) && val.length > 0) this.autoOption.searchField = val[0].searchField ? val[0].searchField : val[0].field;
					await this.$lv.nextTick()
					const newDF = new DynamicFilter(this.lv_curFilterOption)
					newDF.value = this.lv_dynamicFilter.value
					this.lv_dynamicFilter = newDF
				}
			},
			searchField(val) {
				this.lv_searchField !== val && (this.lv_searchField = val);
			},
			async lv_searchField(val) {
				if (val === this.searchField) return
				await this.$lv.nextTick()
				this.$emit('update:searchField', val);
				this.lv_dynamicFilter = new DynamicFilter(this.lv_curFilterOption)
			},
			lv_dynamicFilter(val) {
				this.$emit('update:dynamicFilter', val)
			},
		},
		data() {
			return {
				lv_searchField: this.searchField,                                               //当前搜索字段
				lv_dynamicFilter: this.dynamicFilter || new DynamicFilter(),
			}
		},
		computed: {
			/**
			 * 搜索的字段
			 * @author  韦胜健
			 * @date    2019/9/27 14:10
			 */
			lv_linkFilterOptions() {
				const linkFilterOptions = (this.linkFilterOptions || []).filter(item => item.column.search !== false)
				if (!linkFilterOptions || linkFilterOptions.length === 0) return []
				/*如果不需要加上id字段，则直接返回linkFilterOptions*/
				if (!this.autoOption.defaultSearchIdField) return linkFilterOptions
				else {
					/*需要加上id字段*/
					const idCol = this.$lv.$utils.findOne(linkFilterOptions, item => !!item.field && item.field === 'id')
					if (!!idCol) return linkFilterOptions
					else {
						const idColumn = {title: 'ID', field: 'id', filterName: 'input'}
						return [...linkFilterOptions, AutoTableFilter.getLinkFilterOption(idColumn)]
					}
				}
			},
			/**
			 * 字段映射filterOption，方便查询
			 * @author  韦胜健
			 * @date    2019/9/27 14:21
			 */
			lv_filterOptionMap() {
				return this.lv_linkFilterOptions.reduce((ret, fo) => {
					ret[fo.field] = fo
					return ret
				}, {})
			},
			/**
			 * 当前筛选配置对象
			 * @author  韦胜健
			 * @date    2019/9/27 14:52
			 */
			lv_curFilterOption() {
				return this.lv_filterOptionMap[this.lv_searchField]
			},
		},
		methods: {
			search() {
				this.$refs.filter.$refs.filter.confirm()
			},
			handleFilterChange(dynamicFilter) {
				this.$emit('change', dynamicFilter)
			},
		}
	}
</script>

<style lang="scss">
	@include themeify {
		.link-auto-table-search {
			display: flex;

			.link-input {
				border-color: pl-var(color-info) !important;
				outline: none;

				&:not(.link-input-disabled):not(.link-input-readonly):not(.link-input-invalid) {
					border-color: pl-var(color-info) !important;
					outline: none
				}
			}

			.link-dynamic-filter {
				margin: 0 -1px;
				position: relative;
				z-index: 1;
			}

			.link-input {
				.link-input-prefix-icon {
					padding-right: 0 !important;
				}
			}
		}
	}
</style>
